app.component("technique", {
	templateUrl: "app/src/js/components/operationNote/eyeBank/commonComponents/technique/technique.html",
	controller: "techniqueController",
	bindings: {
		data: "<",
		eyeTitle: "@",
	},
});

app.controller("techniqueController", [
	"$scope",
	function ($scope) {
		$scope.techniqueOptions = [
			{ value: "BIG_BUBBLE_AIR", name: "Big Bubble (Air)" },
			{ value: "MANUAL_DISSECTION", name: "Manual Dissection (Melles)" },
			{ value: "FEMTOSECOND_LASER", name: "Femtosecond Laser" },
			{ value: "OTHER", name: "Other (specify)" },
		];
	},
]);